import { contrastRatio } from "utils/onColor";

/**
 * 1NOW-11175: the colour of Design B's hero band, as "r, g, b" for `rgba(var(...), a)`.
 *
 * The band is the solid panel the heading sits on. It is the tenant's button colour when
 * the tenant's heading colour reads on it (4.5:1), else black, else white: a tenant with a
 * gold button and a white heading gets a black band, one with a dark heading gets a light
 * band. The heading colour itself is the tenant's and is never changed here.
 */
const parse = (hex: unknown): string | null => {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex ?? "").trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].replace(/./g, (c) => c + c) : m[1];
  return `#${h.toUpperCase()}`;
};

const rgbOf = (hex: string) => {
  const n = parseInt(hex.slice(1), 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

export const heroBandRgb = (headingColor?: string | null, buttonColor?: string | null): string => {
  const heading = parse(headingColor) ?? "#FFFFFF";
  const candidates = [parse(buttonColor), "#000000", "#FFFFFF"].filter((c): c is string => !!c);
  const pick =
    candidates.find((c) => contrastRatio(heading, c) >= 4.5) ??
    candidates.reduce((best, c) => (contrastRatio(heading, c) > contrastRatio(heading, best) ? c : best));
  return rgbOf(pick);
};
